export default __webpack_public_path__ + "static/media/spiceGirls.0656109d.jpg";